'use strict';
angular.module('programme')

.directive('carouselControls', function (debounce) {
    return {
        restrict: 'A',
        link: function (scope, element)
        {
            scope.hasNext = true;
            scope.hasPrev = false;

            scope.getCurrentIndex = function() {

                var carouselScope = getCarouselScope();

                for (var i = 0; i < carouselScope.slides.length; i++) {

                    var active = true;

                    if (carouselScope.slides[i].slide) {
                        active = carouselScope.slides[i].slide.active;
                    } else {
                        active = carouselScope.slides[i].active;
                    }

                    if (active) {

                        scope.hasPrev = i > 0;
                        scope.hasNext = i < carouselScope.slides.length - 1;

                        return i;
                    }
                }
            };

            scope.goNext = debounce(function ()
            {
                getCarouselScope().next();
                scope.mirrorSlide(scope.getCurrentIndex(), 'next');
            }, 1000);

            scope.goPrev = debounce(function ()
            {
                getCarouselScope().prev();
                scope.mirrorSlide(scope.getCurrentIndex(), 'prev');
            }, 1000);

            function getCarouselScope () {
                return element.isolateScope();
            }
        }
    };
});
